/**
 * TemplateQualitativeAnswerTypeDTO represents a qualitative answer with a score
 * Based on the Java DTO from TemplateQualitativeAnswerTypeDTO
 */
class TemplateQualitativeAnswerTypeDTO {
  /**
   * Constructs a TemplateQualitativeAnswerTypeDTO
   * @param {Object} data - The data to initialize the DTO with
   */
  constructor(data = {}) {
    this.id = data.id || null;
    this.answer = data.answer || null;
    this.score = data.score || null;
  }

  /**
   * Creates a builder for TemplateQualitativeAnswerTypeDTO
   * @returns {TemplateQualitativeAnswerTypeDTO.Builder} A new builder instance
   */
  static builder() {
    return new TemplateQualitativeAnswerTypeDTO.Builder();
  }

  /**
   * Constructs an instance of TemplateQualitativeAnswerTypeDTO from a plain object
   * @param {Object} data The data to create the instance from
   * @returns {TemplateQualitativeAnswerTypeDTO} An instance of TemplateQualitativeAnswerTypeDTO
   */
  static constructFromObject(data) {
    if (data === null || data === undefined) {
      return null;
    }
    return new TemplateQualitativeAnswerTypeDTO(data);
  }
}

/**
 * Builder class for TemplateQualitativeAnswerTypeDTO
 */
TemplateQualitativeAnswerTypeDTO.Builder = class Builder {
  constructor() {
    this._id = null;
    this._answer = null;
    this._score = null;
  }

  id(id) {
    this._id = id;
    return this;
  }

  answer(answer) {
    this._answer = answer;
    return this;
  }

  score(score) {
    this._score = score;
    return this;
  }

  build() {
    return new TemplateQualitativeAnswerTypeDTO({
      id: this._id,
      answer: this._answer,
      score: this._score
    });
  }
};

export default TemplateQualitativeAnswerTypeDTO;
